import 'react'
import { useMutation } from 'react-query'
import axios from 'axios'
import { API_URL } from '../../config'

export const updateVendorItem = async (updateVendorItem) => {
  const { id, ...changedFields } = updateVendorItem

  if (!id) throw 'No Id Supplied'
  //MAKING THE UPDATE API CALL
  const updateVendorItemAPIPath = `${API_URL}/api/vendor/v1/update/${id}`
  const res = await axios.patch(updateVendorItemAPIPath, changedFields)
  return res.data
}

export function useUpdateVendor() {
  return useMutation(updateVendorItem)
}

export const addVendorItem = async (newItem) => {
  const addVendorItemAPIPath = `${API_URL}/api/vendor/v1/new`
  return await axios.post(addVendorItemAPIPath, newItem)
}

export function useAddVendor() {
  return useMutation(addVendorItem)
}

export const deleteVendorItem = async ({ id }) => {
  if (!id) throw 'Supply Id to delete'
  const deleteVendorItemAPIPath = `${API_URL}/api/vendor/v1/${id}`
  return await axios.delete(deleteVendorItemAPIPath)
}

export function useDeleteVendor() {
  return useMutation(deleteVendorItem)
}
